import React from "react"
import Reactions from "../reactions"
import ArticleMetaData from "./ArticleMetadata"
import FormCK from "../FormCK"
import BlogFooter from "../blogFooter"
import { Container, Heading, Paragraph, Link } from "@theme-ui/components"

const RelatedArticles = ({ articles, title }) => {
  return (
    <>
      <Heading sx={{ mt: 2 }} as="h4">
        Continue reading about {title}
      </Heading>
      <Paragraph sx={{ mb: 1 }}>
        Semantically similar articles hand-picked by GPT-4
      </Paragraph>
      <ul>
        {articles.map((article) => (
          <li key={article.url}>
            <Link href={article.url}>{article.title}</Link>
          </li>
        ))}
      </ul>
    </>
  )
}

const ArticleFooter = (props) => {
  const contentUpgrade = props.pageContext.frontmatter.content_upgrade
  const CustomForm =
    contentUpgrade && require("../FormCK/ContentUpgrades")[contentUpgrade]

  return (
    <Container>
      <ArticleMetaData frontmatter={props.pageContext.frontmatter} />
      <Reactions page={props.uri} />

      {props.pageContext.relatedArticles ? (
        <RelatedArticles
          articles={props.pageContext.relatedArticles}
          title={props.pageContext.frontmatter.title}
        />
      ) : null}
      {CustomForm ? <CustomForm footer={true} /> : <FormCK />}
      <BlogFooter />
    </Container>
  )
}

export default ArticleFooter
